import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PointsViewColumnViewModelStates } from '../states';
import { columnViewModelFeatureKey2 } from '../reducers/root';
export const ViewModelSelector = createFeatureSelector<PointsViewColumnViewModelStates>(columnViewModelFeatureKey2);
export const selectGenericDocPointsListing_State = createSelector(
  ViewModelSelector, 
 (state: PointsViewColumnViewModelStates) => state.column1ViewModel.genericDocPointsListingState
);